/* eslint-disable prefer-const */
'use client';
'use cache';

import { useEffect, useMemo, useState } from 'react';
import Icon from '@/components/atoms/icon';
import Skeleton from '@/components/atoms/skeletons';
import Empty from '@/components/atoms/empty';
import { FiCheckCircle, FiX } from 'react-icons/fi';
import { checkVoucher, getListPlans } from '@/services/apis/modules/plans';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { FaCheckCircle } from 'react-icons/fa';
import {
  addonDownloadExcel,
  addonDownloadPNGJPEG,
  addonViewIndicatorOnChart,
  addonDownloadPDFSVG,
  addonMapping,
  addonLogin,
  addonRestAPI,
  addonDataAI,
  addonDownloadDataset,
} from '@/statics/static';
import React from 'react';
import { errorsMessage } from '@/libs/errors';
import { PlanItem, ResponsePlans } from '@/interfaces/plans';
import { ISelectType } from '@/components/atoms/select';
import { useRouter } from 'next/navigation';
import { AiOutlineArrowRight } from 'react-icons/ai';
import Table from '@/components/molecules/table';
import { mapModifiers } from '@/utils/funtion';
import { Segmented } from 'antd';
import { useData } from '@/stores/context';
import ModalVoucher from './voucher-modal';

const segmentedData = [
  { label: <>1 Tháng</>, value: 'monthly' },
  {
    label: (
      <>
        3 Tháng <span>(giảm 10%)</span> <p>10%</p>
      </>
    ),
    value: 'quarter',
  },
  {
    label: (
      <>
        6 Tháng <span>(giảm 15%)</span> <p>15%</p>
      </>
    ),
    value: 'halfYear',
  },
  {
    label: (
      <>
        12 Tháng <span>(giảm 20%)</span>
        <p>20%</p>
      </>
    ),
    value: 'year',
  },
];

export const coefficientMapping: Record<string, number> = {
  monthly: 1,
  quarter: 3,
  halfYear: 6,
  year: 12,
};

export const coefficientValues: Record<string, number> = {
  monthly: 1,
  quarter: 0.9,
  halfYear: 0.85,
  year: 0.8,
};

interface IProps {
  isInPfofile?: boolean;
}

const PlansModule: React.FC<IProps> = ({ isInPfofile }) => {
  const router = useRouter();
  const { innerWidth, userInfo, setPlans } = useData();
  const [plansList, setPlansList] = useState<PlanItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [coefficient, setCoefficient] = useState(1);
  const [plansActive, setPlansActive] = useState<string | undefined>(undefined);
  const [coefficientValue, setCoefficientValue] = useState(1);
  const initialIndex =
    plansList?.findIndex((item) => item.id === plansActive) ?? 0;
  useEffect(() => {
    handleGetPlans();
  }, []);

  const [voucher, setVoucher] = useState({
    id: '' as any,
    open: false,
    loading: false,
  });

  const [voucherValue, setVoucherValue] = useState('');
  const [voucherError, setVoucherError] = useState('');

  const handleGetPlans = async () => {
    setIsLoading(true);
    const result: ResponsePlans = await getListPlans();
    let sortedPlans = result?.data;
    const plansSelected = result?.data?.map((i) => {
      return {
        id: i.id,
        label: i.name,
        name: i.name,
        value: i.id,
        price: i.price,
      };
    });

    setTimeout(() => {
      setPlans(plansSelected as ISelectType[]);
      setPlansList(sortedPlans);
      setIsLoading(false);
    }, 200);
  };

  const handleCheckVoucher = async () => {
    if (!voucherValue.trim()) return;
    try {
      setVoucher({
        ...voucher,
        loading: true,
      });
      const res = await checkVoucher({ discountCode: voucherValue });

      if (res?.status) {
        const updatedVoucher = {
          discount_type: res?.data?.discount_type,
          discount_value: res?.data?.discount_value,
        };

        setVoucher({
          ...voucher,
          loading: false,
        });
        return updatedVoucher;
      } else {
        setVoucherError('Mã không hợp lệ');
        setVoucher({
          ...voucher,
          loading: false,
        });
        return null;
      }
    } catch (error) {
      console.error(error);
      setVoucher({
        ...voucher,
        loading: false,
      });
      return null;
    }
  };

  const columns: any = [
    {
      title: '',
      dataIndex: 'feature',
      key: 'feature',
      fixed: 'left',
      width: isInPfofile ? 145 : 240,
      onCell: (record: any) => ({
        colSpan: record.colSpan || 1,
      }),
    },
    ...(plansList || [])?.map((plan, index) => {
      const saveMoney =
        Number(plan?.price * Number(1 - coefficientValue)) * coefficient;
      const params: Record<string, string | number> = {
        plan_id: plan?.id,
        package_name: plan?.name,
        price_per_month: plan?.price,
        coefficient,
        discount: Number(Number(1 - coefficientValue) * 100).toFixed(0),
      };
      const newParams = new URLSearchParams(
        Object.entries(params).map(([key, value]) => [key, value.toString()]),
      ).toString();

      return {
        title: (
          <div
            className={mapModifiers(
              'plan-card',
              index.toString(),
              userInfo?.plan?.id === plan?.id && isInPfofile && !!userInfo?.id
                ? 'active'
                : '',
            )}
          >
            <div className="plan-card-name">{plan?.name}</div>
            <div className="plan-card-description">{plan?.description}</div>
            {isInPfofile || (
              <>
                <div className="plan-card-price">
                  {Number(
                    plan?.price * coefficient * coefficientValue,
                  ).toLocaleString()}
                </div>
                <div
                  className="plan-card-price-per-month"
                  style={{
                    color: Number(plan?.price) === 0 ? '#5f9e45' : '#0489dc',
                  }}
                >
                  {Number(plan?.price) === 0
                    ? 'Miễn phí'
                    : `${Number(plan?.price * coefficientValue).toLocaleString()}/ Tháng`}
                </div>
                {Number(plan?.price) === 0 || coefficient == 1 ? (
                  <span
                    style={{
                      height: 20,
                      width: 25,
                      display: 'block',
                    }}
                  ></span>
                ) : (
                  <div className="plan-card_save">
                    Tiết kiệm đến {saveMoney.toLocaleString()} VNĐ
                  </div>
                )}
              </>
            )}

            {!isInPfofile &&
              (userInfo?.plan?.id === plan.id && !!userInfo?.id ? (
                <div className="plan-card-check">
                  <FaCheckCircle />
                </div>
              ) : (
                <div
                  className="plan-card-btn"
                  onClick={() => {
                    setVoucher({
                      ...voucher,
                      id: plan.id,
                      open: true,
                    });
                  }}
                >
                  <a>Mua ngay</a>
                </div>
              ))}
            <ModalVoucher
              open={voucher.open && voucher.id === plan.id}
              loading={voucher?.loading}
              onCheckVoucher={async () => {
                const updatedVoucher = await handleCheckVoucher();
                if (updatedVoucher) {
                  router.push(
                    isInPfofile
                      ? '/cac-goi-du-lieu'
                      : !userInfo?.id
                        ? `/xac-thuc-nguoi-dung?message=${errorsMessage['not_have_permission']}`
                        : `/don-hang?${newParams}&${updatedVoucher.discount_type === 'fixed' ? `fixed=${updatedVoucher.discount_value}` : `percentage=${updatedVoucher.discount_value}`}&code=${voucherValue}`,
                  );
                }
              }}
              onClose={() => {
                setVoucher({
                  ...voucher,
                  id: '',
                  open: false,
                });
                setVoucherValue('');
                setVoucherError('');
              }}
              onCancelVoucher={() => {
                router.push(
                  isInPfofile
                    ? '/cac-goi-du-lieu'
                    : !userInfo?.id
                      ? `/xac-thuc-nguoi-dung?message=${errorsMessage['not_have_permission']}`
                      : `/don-hang?${newParams}`,
                );
              }}
              voucherValue={voucherValue}
              setVoucherValue={setVoucherValue}
              voucherError={voucherError}
              setVoucherError={setVoucherError}
            />
          </div>
        ),
        dataIndex: plan?.name,
        key: plan?.name,
      };
    }),
  ];

  const dataSource = (() => {
    const allFeatures = Object.keys(addonMapping);
    const rows = allFeatures.map((feature) => {
      const row: any = { key: 'function', feature: addonMapping[feature] };
      (plansList || [])?.forEach((plan) => {
        const hasAddon = plan?.addons?.includes(feature);
        const hasDiff = plan?.plansDiff?.includes(feature);
        const hasFree = [
          'view_data_without_details',
          'trend_image_daily_data_unlimit_slot',
        ].includes(feature);
        row[plan?.name] = hasFree ? (
          <div className="plan-icon">
            <Icon component={<FiCheckCircle />} className="check" />
          </div>
        ) : hasAddon ? (
          <div className="plan-icon">
            <Icon component={<FiCheckCircle />} className="check" />
          </div>
        ) : hasDiff ? (
          <div className="plan-icon">
            <Icon component={<FiX />} className="fix" />
          </div>
        ) : null;
      });
      return row;
    });

    const additionalRows: any = [
      {
        key: 'additional',
        feature: 'Giá (tính cho 1 tháng)',
        ...plansList?.reduce((acc: any, plan: any, currentIndex: number) => {
          if (plan?.name) {
            acc[plan.name] = currentIndex < 2 ? '49.000 VND/lượt' : 'Miễn phí';
          }
          return acc;
        }, {}),
      },
    ];

    const benefitsRow = {
      key: 'benefits',
      feature: '',
      ...plansList?.reduce((acc: Record<string, string>, plan, index) => {
        // acc[plan?.name] = index === Number(plansList.length / 2) - 1 ? "Quyền lợi" : "";
        acc[plan?.name] = index === 2 ? 'Quyền lợi' : '';
        return acc;
      }, {}),
    };

    const downloadPNGRow = {
      key: 'downloadPng',
      feature: 'Download data dạng hình (PNG, JPEG)',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonDownloadPNGJPEG).find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'trend_image_pdf_12_slot':
                acc[plan?.name] = '12 lượt/tháng';
                break;
              case 'trend_image_pdf_60_slot':
                acc[plan?.name] = '60 lượt/tháng';
                break;
              case 'trend_image_pdf_120_slot':
                acc[plan?.name] = '120 lượt/tháng';
                break;
              case 'trend_image_pdf_unlimit_slot':
                acc[plan?.name] =
                  index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';
                break;
              default:
                acc[plan?.name] = 'Không có';
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const downloadPDFRow = {
      key: 'downloadPDF',
      feature: 'Download data dạng PDF/SVG',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonDownloadPDFSVG).find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'trend_pdf_svg_12_slot':
                acc[plan?.name] = '12 lượt/tháng';
                break;
              case 'trend_pdf_svg_60_slot':
                acc[plan?.name] = '60 lượt/tháng';
                break;
              case 'trend_pdf_svg_120_slot':
                acc[plan?.name] = '120 lượt/tháng';
                break;
              case 'trend_pdf_svg_unlimit_slot':
                acc[plan?.name] =
                  index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';
                break;
              default:
                acc[plan?.name] = 'Không có';
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const viewIndicatorOnChartRow = {
      key: 'viewIndicatorOnChartRow',
      feature: 'Xem dữ liệu',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonViewIndicatorOnChart)?.find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'view_last_12_periods':
                acc[plan?.name] = 'Tối đa 12 kỳ gần nhất';
                break;
              case 'view_unlimited_data':
                acc[plan?.name] =
                  index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';
                break;

              default:
                acc[plan?.name] = (
                  <div className="plan-icon">
                    <Icon component={<FiX />} className="fix" />
                  </div>
                );
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const selectRangeRow = {
      key: 'selectRangeRow',
      feature: 'Chọn số kỳ hiển thị',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonViewIndicatorOnChart)?.find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'view_last_12_periods':
                acc[plan?.name] = (
                  <div className="plan-icon">
                    <Icon component={<FiX />} className="fix" />
                  </div>
                );
                break;
              case 'view_unlimited_data':
                acc[plan?.name] =
                  index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';
                break;

              default:
                acc[plan?.name] = (
                  <div className="plan-icon">
                    <Icon component={<FiX />} className="fix" />
                  </div>
                );
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const addonDownloadDatasetRow = {
      key: 'addonDownloadDataset',
      feature: 'Download dataset (Excel/CSV)',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonDownloadDataset)?.find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'dataset_10_slot':
                acc[plan?.name] = '10 lượt/tháng';
                break;
              case 'dataset_20_slot':
                acc[plan?.name] = '10 lượt/tháng';
                break;
              case 'dataset_unlimit_slot':
                acc[plan?.name] =
                  index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';
                break;
              default:
                acc[plan?.name] = (
                  <div className="plan-icon">
                    <Icon component={<FiX />} className="fix" />
                  </div>
                );
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const downloadExcelRow = {
      key: 'downloadExcel',
      feature: 'Download data chi tiết (Excel/CSV)',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonDownloadExcel)?.find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'trend_forecast':
                acc[plan?.name] = '49,000 VND/lượt';
                break;
              case 'trend_forecast_10_slot':
                acc[plan?.name] = '10 lượt/tháng';
                break;
              case 'trend_forecast_50_slot':
                acc[plan?.name] = '50 lượt/tháng';
                break;
              case 'trend_forecast_200_slot':
                acc[plan?.name] = '100 lượt/tháng';
                break;
              case 'trend_forecast_100_slot':
                acc[plan?.name] = '100 lượt/tháng';
                break;
              case 'trend_forecast_unlimit_slot':
                // acc[plan?.name] = (
                //   <div className="plan-icon">
                //     <Icon component={<FiCheckCircle />} className="check" />
                //   </div>
                // );
                acc[plan?.name] =
                  index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';

                break;
              default:
                acc[plan?.name] = (
                  <div className="plan-icon">
                    <Icon component={<FiX />} className="fix" />
                  </div>
                );
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const downloadReportRow = {
      key: 'downloadReport',
      feature: 'Download báo cáo phân tích',
      ...plansList?.reduce((acc: Record<string, string>, plan, index) => {
        const nameFree = ['premium', 'professional'];
        const checkFree = nameFree.includes(plan?.name?.toLowerCase());
        if (checkFree)
          acc[plan?.name] =
            index === 0 ? 'Không hạn chế 1 tuần' : 'Không hạn chế';
        else acc[plan?.name] = 'Một số báo cáo';
        return acc;
      }, {}),
    };

    const restSPIRow = {
      key: 'restSPIRow',
      feature: 'REST API chỉ số',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan) => {
          const addonKey = Object.keys(addonRestAPI).find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'rest_api_indices_5_fields':
                acc[plan?.name] = '20 chỉ số';
                break;
              case 'rest_api_indices_10_fields':
                acc[plan?.name] = '20 chỉ số';
                break;
              case 'rest_api_indices_20_fields':
                acc[plan?.name] = '20 chỉ số';
                break;
              case 'rest_api_indices_unlimit_fields':
                acc[plan?.name] = 'Không hạn chế';
                break;
              default:
                acc[plan?.name] = 'Không có';
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const dataAIRow = {
      key: 'dataAIRow',
      feature: 'Phân tích dữ liệu bằng AI',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan, index) => {
          const addonKey = Object.keys(addonDataAI).find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'ai_data_analysis_10_request':
                acc[plan?.name] =
                  index === 0
                    ? 'Giới hạn 10 yêu cầu (thử 1 tuần)'
                    : 'Giới hạn 10 yêu cầu';

                break;
              case 'ai_data_analysis_50_request':
                acc[plan?.name] =
                  index === 0
                    ? 'Giới hạn 50 yêu cầu (thử 1 tuần)'
                    : 'Giới hạn 50 yêu cầu';

                break;
              case 'ai_data_analysis_200_request':
                acc[plan?.name] =
                  index === 0
                    ? 'Giới hạn 200 yêu cầu (thử 1 tuần)'
                    : 'Giới hạn 200 yêu cầu';

                break;
              default:
                acc[plan?.name] = (
                  <div className="plan-icon">
                    <Icon component={<FiX />} className="fix" />
                  </div>
                );
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    const loginRow = {
      key: 'loginRow',
      feature: 'Đa người dùng',
      ...plansList?.reduce(
        (acc: Record<string, string | JSX.Element>, plan) => {
          const addonKey = Object.keys(addonLogin).find((key) =>
            plan?.addons?.includes(key),
          );

          if (addonKey) {
            switch (addonKey) {
              case 'mutible_login_one':
                acc[plan?.name] = '1 người dùng';
                break;
              case 'mutible_login_three':
                acc[plan?.name] = '3 người dùng';
                break;
              case 'mutible_login_five':
                acc[plan?.name] = '10 người dùng';
                break;
              case 'mutible_login_ten':
                acc[plan?.name] = '10 người dùng';
                break;
              default:
                acc[plan?.name] = 'Không có';
            }
          } else {
            acc[plan?.name] = (
              <div className="plan-icon">
                <Icon component={<FiX />} className="fix" />
              </div>
            );
          }

          return acc;
        },
        {},
      ),
    };

    return [
      !isInPfofile && benefitsRow,
      ...rows,
      dataAIRow,
      // addonDownloadDatasetRow,
      selectRangeRow,
      viewIndicatorOnChartRow,
      downloadExcelRow,
      downloadPDFRow,
      downloadPNGRow,
      downloadReportRow,
      loginRow,
      restSPIRow,
    ];
  })();

  const renderPlanCardTabletDown = useMemo(() => {
    setPlansActive((plansList || [])[0]?.id);
    return (
      <Swiper
        className={mapModifiers('plan-mobile', isInPfofile ? 'in-profile' : '')}
        slidesPerView={1.3}
        spaceBetween={15}
        pagination={{
          clickable: true,
        }}
        initialSlide={initialIndex}
        modules={[Pagination]}
      >
        {!plansList?.length ? (
          <Empty />
        ) : (
          plansList?.map((item: any, index) => {
            const params: Record<string, string | number> = {
              plan_id: item?.id,
              package_name: item?.name,
              price_per_month: item?.price,
              coefficient,
              discount: Number(Number(1 - coefficientValue) * 100).toFixed(0),
            };
            const newParams = new URLSearchParams(
              Object.entries(params).map(([key, value]) => [
                key,
                value.toString(),
              ]),
            ).toString();
            return (
              <SwiperSlide key={item.id}>
                <div
                  className={mapModifiers(
                    'plan-mobile_card',
                    index.toString(),
                    item.id === userInfo?.plan?.id && !!userInfo?.id
                      ? 'active'
                      : '',
                  )}
                >
                  <div className="plan-mobile_card_name">{item?.name}</div>
                  <div className="plan-mobile_card_desc">
                    {item?.description}
                  </div>
                  {isInPfofile || (
                    <>
                      <div className="plan-mobile_card_price">
                        {Number(
                          item?.price * coefficient * coefficientValue,
                        ).toLocaleString()}
                      </div>
                      <div className="plan-mobile_card_month">
                        {Number(item?.price) === 0
                          ? 'Miễn phí'
                          : `${Number(item?.price * coefficientValue).toLocaleString()}/ Tháng`}
                      </div>
                      <div className="plan-mobile_card_save">
                        {Number(item?.price) === 0 || coefficient == 1 || (
                          <>
                            Tiết kiệm đến{' '}
                            {(
                              Number(
                                item?.price * Number(1 - coefficientValue),
                              ) * coefficient
                            ).toLocaleString()}{' '}
                            VNĐ
                          </>
                        )}
                      </div>
                    </>
                  )}
                  {userInfo?.plan?.id === item?.id && !!userInfo?.id ? (
                    <div className="plan-mobile_card_check">
                      <FaCheckCircle />
                    </div>
                  ) : (
                    <>
                      <div
                        onClick={() => {
                          // router.push(
                          //   isInPfofile
                          //     ? '/cac-goi-du-lieu'
                          //     : !userInfo?.id
                          //       ? `/xac-thuc-nguoi-dung?message=${errorsMessage['not_have_permission']}`
                          //       : `/don-hang?${newParams}`,
                          // );
                          setVoucher({
                            ...voucher,
                            id: item.id,
                            open: true,
                          });
                        }}
                        className="plan-mobile_card_btn"
                      >
                        Mua ngay <AiOutlineArrowRight />
                      </div>
                      <ModalVoucher
                        open={voucher.open && voucher.id === item.id}
                        loading={voucher?.loading}
                        onCheckVoucher={async () => {
                          const updatedVoucher = await handleCheckVoucher();
                          if (updatedVoucher) {
                            router.push(
                              isInPfofile
                                ? '/cac-goi-du-lieu'
                                : !userInfo?.id
                                  ? `/xac-thuc-nguoi-dung?message=${errorsMessage['not_have_permission']}`
                                  : `/don-hang?${newParams}&${updatedVoucher.discount_type === 'fixed' ? `fixed=${updatedVoucher.discount_value}` : `percentage=${updatedVoucher.discount_value}`}&code=${voucherValue}`,
                            );
                          }
                        }}
                        onClose={() => {
                          setVoucher({
                            ...voucher,
                            id: '',
                            open: false,
                          });
                          setVoucherValue('');
                          setVoucherError('');
                        }}
                        onCancelVoucher={() => {
                          router.push(
                            isInPfofile
                              ? '/cac-goi-du-lieu'
                              : !userInfo?.id
                                ? `/xac-thuc-nguoi-dung?message=${errorsMessage['not_have_permission']}`
                                : `/don-hang?${newParams}`,
                          );
                        }}
                        voucherValue={voucherValue}
                        setVoucherValue={setVoucherValue}
                        voucherError={voucherError}
                        setVoucherError={setVoucherError}
                      />
                    </>
                  )}

                  <div className="plan-mobile_card_addons">
                    {item?.addons
                      ?.filter((key: string) => addonMapping[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>{addonMapping[addon]}</p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonDataAI[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Phân tích dữ liệu bằng AI: {addonDataAI[addon]}
                            </p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonDownloadPDFSVG[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Download PDF/SVG: {addonDownloadPDFSVG[addon]}
                            </p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonDownloadPNGJPEG[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Download PNG/JPEG: {addonDownloadPNGJPEG[addon]}
                            </p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonDownloadExcel[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Download Excel/CSV: {addonDownloadExcel[addon]}
                            </p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonViewIndicatorOnChart[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Xem dữ liệu: {addonViewIndicatorOnChart[addon]}
                            </p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonViewIndicatorOnChart[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Chọn số kỳ hiển thị:{' '}
                              {addonViewIndicatorOnChart[addon]}
                            </p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonLogin[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>Đa thiết bị: {addonLogin[addon]}</p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonRestAPI[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>Rest API: {addonRestAPI[addon]}</p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonLogin[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>Download báo cáo: {addonLogin[addon]}</p>
                          </div>
                        );
                      })}
                    {item?.addons
                      ?.filter((key: string) => addonDownloadDataset[key])
                      .map((addon: string, index: number) => {
                        return (
                          <div key={index}>
                            <div className="plan-mobile_card_addons_icon">
                              <FiCheckCircle />
                            </div>
                            <p>
                              Download dataset (Excel/CSV):{' '}
                              {addonDownloadDataset[addon]}
                            </p>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    );
  }, [
    plansList,
    plansActive,
    coefficientValue,
    coefficient,
    voucher,
    userInfo,
  ]);

  return (
    <div
      className={mapModifiers('plans-module', isInPfofile ? 'in-profile' : '')}
    >
      <div className="plans-module-wrapper">
        {isInPfofile || (
          <>
            <div className="plans-module-title page-title">Các gói dịch vụ</div>
            <div className="plans-module-sub-title">
              Lựa chọn dịch vụ phù hợp và tận hưởng những ưu đãi đặc biệt từ
              chúng tôi
            </div>
            <div
              className={mapModifiers(
                'plans-module-payment_type',
                isLoading ? 'loading' : '',
              )}
            >
              {isLoading ? (
                <Skeleton
                  type="node"
                  style={{
                    width: innerWidth > 780 ? '50%' : '100%',
                    height: 50,
                    borderRadius: 50,
                  }}
                  active
                />
              ) : (
                <Segmented
                  options={segmentedData}
                  block
                  size="large"
                  onChange={(value: any) => {
                    const newCoefficient = coefficientMapping[value];
                    const newCoefficientValue = coefficientValues[value];
                    setCoefficient(newCoefficient);
                    setCoefficientValue(newCoefficientValue);
                  }}
                />
              )}
            </div>
          </>
        )}
        <div
          className={mapModifiers(
            'plans-module-table',
            isLoading ? 'loading' : '',
          )}
        >
          {isLoading ? (
            <div className="plans-module_loading_wrapper">
              {innerWidth <= 780 && !isInPfofile ? (
                <Skeleton
                  type="node"
                  style={{
                    width: '100%',
                    height: 500,
                  }}
                  active
                />
              ) : (
                <>
                  <div className="plans-module_loading_header">
                    <span />
                    <Skeleton
                      type="node"
                      style={{ width: '40%', minHeight: 500 }}
                      active
                    />
                    <Skeleton
                      type="node"
                      style={{ width: '40%', minHeight: 500 }}
                      active
                    />
                    <Skeleton
                      type="node"
                      style={{ width: '40%', minHeight: 500 }}
                      active
                    />
                    <Skeleton
                      type="node"
                      style={{ width: '40%', minHeight: 500 }}
                      active
                    />
                    <Skeleton
                      type="node"
                      style={{ width: '40%', minHeight: 500 }}
                      active
                    />
                    <Skeleton
                      type="node"
                      style={{ width: '40%', minHeight: 500 }}
                      active
                    />
                  </div>
                  <Skeleton
                    type="node"
                    style={{
                      width: '100%',
                      height: 250,
                      minHeight: 250,
                      maxHeight: 250,
                    }}
                    active
                  />
                  <Skeleton
                    type="node"
                    style={{
                      width: '100%',
                      height: 60,
                      minHeight: 60,
                      maxHeight: 60,
                    }}
                    active
                  />
                  <Skeleton
                    type="node"
                    style={{ width: '100%', height: 500 }}
                    active
                  />
                </>
              )}
            </div>
          ) : plansList?.length > 0 ? (
            innerWidth <= 780 && !isInPfofile ? (
              renderPlanCardTabletDown
            ) : (
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                scroll={{
                  x: true,
                }}
              />
            )
          ) : (
            <Empty />
          )}
        </div>
      </div>
    </div>
  );
};

export default PlansModule;
